import { useRecoilState } from 'recoil';

import { userSettingsOpenState } from 'state/project';
import { SettingsForm } from '@/pages/Settings';

export default function UserSettingsModal() {
  const [open, setOpen] = useRecoilState(userSettingsOpenState);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-start md:items-center justify-center p-0 md:p-8 lg:p-10 bg-black/70 backdrop-blur-md animate-backdrop-in"
      onClick={(e) => {
        if (e.target === e.currentTarget) setOpen(false);
      }}
    >
      <main className="fongpt-settings w-full md:max-w-[1080px] h-full md:h-[min(82vh,760px)] panel md:rounded-[24px] overflow-hidden flex flex-col md:flex-row shadow-2xl animate-settings-in relative">
        <SettingsForm inModal onClose={() => setOpen(false)} />
      </main>
    </div>
  );
}
